package br.com.texeratx.boardgametimeapp.data.model.login

import kotlinx.serialization.Serializable

@Serializable
data class ForgotPasswordRequest(
    val email: String
)
